export const FETCH_SEO_CONTENT = 'fetchSeoContent'
export const FETCHED_SEO_CONTENT = 'fetchedContent'
export const SET_SEO_CONTENT_TYPE = 'setContentType'
